export { NIconWrapper, iconWrapperProps } from './src/IconWrapper';
